// extracted by mini-css-extract-plugin
module.exports = {"list":"list___2fN-r","dictionaries__list":"dictionaries__list___Bd0QU"};